// extracted by mini-css-extract-plugin
export default {"root":"Radio_root__+1sJp","checkmark":"Radio_checkmark__aP9Ta","size-big":"Radio_size-big__0B9Az","size-medium":"Radio_size-medium__t2nZx","size-tiny":"Radio_size-tiny__b5fP4"};